import React, { useContext } from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { HashLink } from "react-router-hash-link";
import { SearchResultPlan } from "../../@types";
import EnrollButtonForm from "../EnrollButtonForm";
import {
  useTranslate,
  sendTealiumEvent,
  makePlanLongId,
  IntlContext,
} from "../../helpers";
import routes from "../../app/routes";
import AddToCompare from "./AddToCompare";

interface PlanCardActionsProps extends RouteComponentProps {
  plan: SearchResultPlan;
  isCurrentPlan?: boolean;
  handleAddToCompare?: (plan: SearchResultPlan) => void;
  handleRemoveFromCompare?: (removeId: number | string) => void;
  hideCompareButton?: boolean;
}

const PlanCardActions: React.FunctionComponent<PlanCardActionsProps> = ({
  plan,
  isCurrentPlan,
  location,
  handleAddToCompare,
  handleRemoveFromCompare,
  hideCompareButton,
}) => {
  const t = useTranslate();
  const fm = useContext(IntlContext).formatMessage;
  const aria_string = `${t("plan_card.enroll_in")} ${plan.name}`;

  return (
    <div className="PlanCard__actions mct-hide-print">
      {!isCurrentPlan && (
        <EnrollButtonForm
          plan={plan}
          aria_string={aria_string}
          tealiumEventAction="Find Plans - Available Plans"
        />
      )}
      <HashLink
        to={`${routes.planDetails.replace(":id", makePlanLongId(plan))}${
          location.search
        }`}
        className="ds-c-button ds-c-button--primary-alt PlanCard__mobile_order_3"
        onClick={(): void => {
          // istanbul ignore next: tested elsewhere
          sendTealiumEvent(
            "Find Plans - Available Plans",
            `Plan Click: ${plan.name}`
          );
        }}
        aria-label={fm(
          {
            id: "plan_card.plan_details_for",
          },
          { planName: plan.name }
        )}
      >
        {t("plan_card.plan_details")}
      </HashLink>
      <AddToCompare
        plan={plan}
        hide={hideCompareButton}
        handleAddToCompare={handleAddToCompare}
        handleRemoveFromCompare={handleRemoveFromCompare}
      />
    </div>
  );
};

export default withRouter(PlanCardActions);
